// In memory only, so every full page load shows the chooser again.
let seen = false;

export function hasSeenChooser(): boolean {
  return seen;
}

export function markChooserSeen(): void {
  seen = true;
}

/** Simulates a fresh page load in tests. */
export function resetChooserSeen(): void {
  seen = false;
}

const BOT_PATTERN =
  /bot|crawl|spider|slurp|facebookexternalhit|embedly|preview|whatsapp|telegram|slack|discord|linkedin|twitter|pinterest|lighthouse/i;

export function isBot(): boolean {
  if (typeof navigator === "undefined") return false;
  return BOT_PATTERN.test(navigator.userAgent);
}
